import axios from '@axios'

const PREFIX = '/funcoes'

export default {

  getFuncoes(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getFuncao(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  updateFuncao(id, depart) {
    return axios.put(`${PREFIX}/${id}`, depart)
  },

  createFuncao(depart) {
    return axios.post(`${PREFIX}/add`, depart)
  },

  deleteFuncao(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  getFuncoesFiltradas(nome, externo) {
    if (externo) {
      return axios.get(`${PREFIX}/portal-propostas/filtro-funcoes?nome=${nome}`)
    }
    return axios.get(`${PREFIX}/filtro-funcoes?nome=${nome}`)
  },

}
